/**
 * Custom event tracker that will send custom events to Fullstory
 *
 * @param eventName
 * @param options
 */

export const reportEvent = (
  eventName: string,
  eventData?: { [key: string]: string | number }
): void => {
  window.FS?.event(eventName, eventData as object);
};
